import {createSelector, MemoizedSelector} from '@ngrx/store';
import {Dibujo, dibujosAdapter, DibujosState} from './dibujos.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {DibujoType} from '../../../../../chacra-core';

export const getError = (state: DibujosState): any => state.error;

export const getIsLoading = (state: DibujosState): boolean =>
  state.isLoading;

export const selectDibujosState = createSelector(
  selectFeatures, (state: FeaturesState) => state.dibujos
);

export const selectAllDibujos: (state: object) => Dibujo[] =
  dibujosAdapter.getSelectors(selectDibujosState).selectAll;

export const selectAllDibujosByTipo = (tipo: DibujoType) =>
  createSelector(
    selectAllDibujos,
    (allDibujos: Dibujo[]) => {
      if (allDibujos) {
        return allDibujos.filter(d => d.dibujoTipo === tipo);
      } else {
        return [];
      }
    }
  );

export const selectDibujoById = (id: number) =>
  createSelector(
    selectAllDibujos,
    (allDibujos: Dibujo[]) => {
      if (allDibujos) {
        return allDibujos.find(d => d.dibujoId === id);
      } else {
        return null;
      }
    }
  );

export const selectDibujosError: MemoizedSelector<object, any> = createSelector(
  selectDibujosState,
  getError
);

export const selectDibujosIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDibujosState,
  getIsLoading
);
